/* eslint-disable no-param-reassign */

// https://css-tricks.com/using-css-transitions-auto-dimensions/

export const collapseElement = (ref, collapseHeight = "0rem") => {
  if (!ref || !ref.current) return
  const height = ref.current.scrollHeight
  const elementTransition = ref.current.style.transition
  ref.current.style.transition = ""

  requestAnimationFrame(() => {
    ref.current.style.height = `${height / 10}rem`
    ref.current.style.transition = elementTransition

    requestAnimationFrame(() => {
      ref.current.style.height = collapseHeight
    })
  })
}

export const expandElement = ref => {
  if (!ref || !ref.current) return
  const height = ref.current.scrollHeight
  ref.current.style.height = `${height / 10}rem`

  const transitioned = () => {
    ref.current.removeEventListener("transitioned", transitioned)
    ref.current.style.height = null
  }
  ref.current.addEventListener("transitioned", transitioned)
}
